export const CHARS_LENGTH = {
  MAX_COMMON: 50,
  MAX_EMAIL: 128,
  MAX_TEL_NUMBER: 20,
  MAX_ZONE_NAME: 30,
  MAX_EQUIP_NAME: 20,
  MIN_PASSWORD: 10,
  MAX_PASSWORD: 64,
};
